import { getAppConfig } from "config/client.config";
export const GET_COURSE_LIST = "GET_COURSE_LIST";
export const ADD_COURSE = "ADD_COURSE";
export const DELETE_COURSE = "DELETE_COURSE";
export const DUPLICATE_COURSE = "DUPLICATE_COURSE";

const _getCourses = (status, data, err) => {
    return {
        type: GET_COURSE_LIST,
        data,
        err,
        status,
    };
};
const _addCourse = (status, data, err) => {
    return {
        type: ADD_COURSE,
        data,
        err,
        status,
    };
};
const _deleteCourse = (status, data, err) => {
    return {
        type: DELETE_COURSE,
        data,
        err,
        status,
    };
};
const _duplicateCourse = (status, data, err) => {
    return {
        type: DUPLICATE_COURSE,
        data,
        err,
        status,
    };
};

const getCourses = () => {
    return (dispatch, getState, Request) => {
        let getCoursesPath = getAppConfig().endpoints.builderPaths[
            "getCoursesPath"
        ];
        return Request.fetch(getCoursesPath)
            .then((response) => {
                return response.json().then((data) => {
                    return dispatch(
                        _getCourses(
                            "success",
                            {
                                courses: data,
                                userId: getState().auth.user.id,
                                license: getState().auth.user.license
                                    .license_type,
                            },
                            null
                        )
                    );
                });
            })
            .catch((err) => {
                console.log(err);
                return dispatch(_getCourses("error", null, err));
            });
    };
};
const addCourse = (name, description, category, sequential, courseType) => {
    return (dispatch, getState, Request) => {
        let addCoursePath = getAppConfig().endpoints.builderPaths[
            "addCoursePath"
        ];
        return Request.fetch(addCoursePath, {
            method: "POST",
            body: JSON.stringify({
                parent: category,
                wrapper: "none",
                name: name,
                description: description,
                sequential: sequential,
                course_type: courseType
            }),
        })
            .then((response) => {
                return response.json().then((data) => {
                    return dispatch(
                        _addCourse(
                            "success",
                            {
                                course: data,
                            },
                            null
                        )
                    );
                });
            })
            .catch((err) => {
                console.log(err);
                return dispatch(_addCourse("error", null, err));
            });
    };
};
const deleteCourse = (courseId) => {
    return (dispatch, getState, Request) => {
        let deleteCoursePath = getAppConfig().endpoints.builderPaths[
            "deleteCoursePath"
        ].replace(":id", courseId);
        return Request.fetch(deleteCoursePath, {
            method: "POST",
        })
            .then((response) => {
                return response.json().then((data) => {
                    return dispatch(
                        _deleteCourse("success", { id: courseId }, null)
                    );
                });
            })
            .catch((err) => {
                console.log(err);
                return dispatch(_deleteCourse("error", null, err));
            });
    };
};
const duplicateCourse = (courseId) => {
    return (dispatch, getState, Request) => {
        let duplicateCoursePath = getAppConfig().endpoints.builderPaths[
            "duplicateCoursePath"
        ].replace(":id", courseId);
        return Request.fetch(duplicateCoursePath, {
            method: "POST",
        })
            .then((response) => {
                return response.json().then((data) => {
                    return dispatch(
                        _duplicateCourse("success", { id: courseId, course: data }, null)
                    );
                });
            })
            .catch((err) => {
                return dispatch(_duplicateCourse("error", null, err));
            });
    };
};

class LearnerManagerAction {
    static getCourses = getCourses;
    static addCourse = addCourse;
    static deleteCourse = deleteCourse;
    static duplicateCourse = duplicateCourse;
}

export default LearnerManagerAction;
